export default function (
  state = {
    node: {},
    copy: false,
    cut: false,
    currentId: 0,
    cutId: null,
    cutConfirm: false,
    nodeType: null,
  },
  action
) {
  switch (action.type) {
    case "COPY_NODE":
      return Object.assign({}, state, {
        node: action.copy,
        cut: false,
        nodeType: action.nodeType,
        copy: true,
      });
    case "ADD_ID":
      var id = state.currentId + 1;
      return Object.assign({}, state, {
        currentId: id,
      });
    case "CUT_CONFIRM":
      return Object.assign({}, state, {
        cutConfirm: true,
      });
    case "CUT_DONE":
      return Object.assign({}, state, {
        cutConfirm: false,
        cutId: null,
      });
    case "CUT_NODE":
      return Object.assign({}, state, {
        node: action.cut,
        cut: true,
        nodeType: action.nodeType,
        copy: true,
        cutId: action.cutId,
      });
    default:
      return state;
  }
}
